import { Row, Col, Panel, Content, Navbar, Button, Dropdown, Whisper, Popover } from "rsuite"
import SettingIcon from '@rsuite/icons/Setting';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { downloadCSV, downloadExcel } from "../briefs/briefCreationManager";

export default function AnalytyicsHeader({data}) {
    const { key } = useParams();

    return (
        <div style={{padding: "1rem", height: "2.5rem", display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
            <Dropdown trigger={"hover"} className="brief-tree-header-dropdown" placement="bottomEnd" title="Скачать">
                <Dropdown.Item onClick={() => downloadCSV(data)}>
                    Скачать в CSV
                </Dropdown.Item>
                <Dropdown.Item onClick={() => downloadExcel(data, "xlsx")}>
                    Скачать в XLSX
                </Dropdown.Item>
            </Dropdown>
        </div>
    )
}